import createReducer from '../../utils/createReducer';
import {
  GET_IDENTIFICATION_TYPES_ERROR,
  GET_IDENTIFICATION_TYPES_SOURCE,
  GET_IDENTIFICATION_TYPES_SUCCESS,
  IDENTIFICATION_SOURCE_DETAILS,
  IDENTIFICATION_SOURCE__DETAILS_SUCCESS,
  IDENTIFICATION_SOURCE_DETAILS_ERROR,
  POST_IDENTIFICATION_INFO_SUCCESS,
  POST_IDENTIFICATION_INFO_ERROR,
} from '../../actions/identificationVerification/identificationVerificationConstants';

const initialState = {
  identificationTypesSources: [],
  error: '',
  loading: false,
  identificationInfoDetails: {},
  identificationData: {},
};

export default createReducer(
  {
    [GET_IDENTIFICATION_TYPES_SOURCE]: startFetchingIdentificationTypes,
    [GET_IDENTIFICATION_TYPES_SUCCESS]: getIdentificationTypeSource,
    [GET_IDENTIFICATION_TYPES_ERROR]: getIdentificationTypeSourceError,
    [IDENTIFICATION_SOURCE_DETAILS]: startFetchingIdentificationDetails,
    [IDENTIFICATION_SOURCE__DETAILS_SUCCESS]: getIdentificationInfoDetails,
    [IDENTIFICATION_SOURCE_DETAILS_ERROR]: getIdentificationInfoDetailsError,
    [POST_IDENTIFICATION_INFO_SUCCESS]: identificationDataSuccess,
    [POST_IDENTIFICATION_INFO_ERROR]: identificationDataError,
  },
  initialState,
);

function startFetchingIdentificationTypes(state) {
  return {
    ...state,
    loading: true,
    error: '',
  };
}
function getIdentificationTypeSource(state, { payload }) {
  return {
    ...state,
    identificationTypesSources: payload,
    error: '',
    loading: false,
  };
}

function getIdentificationTypeSourceError(state, { payload }) {
  return {
    ...state,
    error: payload,
    loading: false,
  };
}
function startFetchingIdentificationDetails(state) {
  return {
    ...state,
    loading: true,
    error: '',
  };
}
function getIdentificationInfoDetails(state, { payload }) {
  return {
    ...state,
    identificationInfoDetails: payload,
    error: '',
    loading: false,
  };
}

function getIdentificationInfoDetailsError(state, { payload }) {
  return {
    ...state,
    error: payload,
    loading: false,
  };
}

function identificationDataSuccess(state, action) {
  return {
    ...state,
    identificationData: action.payload,
    error: '',
    loading: false,
  };
}

function identificationDataError(state, action) {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
}
